
import { mapState, mapGetters } from 'vuex';

export default {
  name: 'AppReviewInfoSection',
  props: {
    review: {
      type: Object,
      required: true
    },
    cols: {
      type: Number,
      default: 1
    },
    messageRows: {
      type: Number,
      default: 1
    }
  },
  computed: {
    ...mapState('reviewSettings', ['reviewSettings']),
    ...mapState('widget', ['widget']),
    ...mapGetters('widget', ['device']),
    ...mapGetters('review', ['showDate', 'showScore'])
  }
};
